var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.confirmLogout}},[_c('app-sidebar-link',{attrs:{"link":_vm.LOGOUT_LINK,"hideTooltips":_vm.disabledTooltip}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }